import gql from 'graphql-tag';

export default gql`
    query GetStageSheet($stageSheetId: Int) {
        getStageSheet(stageSheetId: $stageSheetId) {
            propDetails {
                stageSheetProppantId
                proppantName
                totalWeightNeeded
                sandPumped
                totalBoxWeight
            }
            details {
                stageSheetProppantId
                stageSheetBoxId
                station
                runOrder
                boxDesc
                boxWeight
                boxWeightRemaining
                isOOS
                proppantId
                proppant
                location
                sandPo
                sandTicket
                loadId
                sandTicketLink
                accumulatedWeight
                currentProppantWeight
                isPartial
                loadWeight
                boxId
                isCompleted
                lofaOrigin
                stageSheetBellyDump {
                    id
                    boxId
                    loadId
                    stageSheetBoxId
                    stageSheetProppantId
                    sandTicket
                    isLoadCompleted
                    isPartial
                    sandTicketWeight
                    sandTicketWeightRemaining
                    lastUpdatedDateTimeSBS
                    sBSLastUpdatedBy
                    sandTicketLink
                }
            }
        }
    }
`;
